<template>
  <div v-if="!hide">
    <div class="payment-loading" v-if="isLoading">
      <ui-progress-circular color="black"/>
    </div>
    <div v-show="!isLoading">
      <div id="payment-request-button-google"></div>
    </div>

    <div class="payment-button-error" v-if="error">
      <span v-if="error && $te('errors.'+error)">{{$t('errors.'+error)}}</span>
      <span v-if="error && !$te('errors.'+error)">{{$t('errors.error_please_try_again')}}</span>
    </div>
  </div>
</template>

<style lang="scss">
.payment-button-error
{
  margin-top: 10px;
  span
  {
    color: #be0000;
  }
}
.payment-loading
{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
import config from "@/config";

export default {
  data() {
    return {
      error: false,
      isLoading: true,
      hide: false
    }
  },
  methods: {
    ...mapActions(['walletPreRequestAction', 'walletCompletePaymentAction']),
    endPayment(){
      this.walletCompletePaymentAction()
          .then((data) => {
            this.$router.push({name: 'checkout', params: {merchantSlug: data.checkout.merchant.slug, orderToken: data.checkout.orderToken}});
          })
          .catch((e) => {
            console.log('Error', e);
            this.error = 'error_please_try_again';
          })
    }
  },
  computed: {
    ...mapGetters(['cart'])
  },
  async mounted() {
    this.error = false;
    this.isLoading = true;

    var stripe = Stripe(config.stripe, {
      apiVersion: "2020-08-27",
    });

    const paymentRequest = stripe.paymentRequest({
      country: 'FR',
      currency: 'eur',
      total: {
        label: 'Total',
        amount: this.cart.values.total.value,
      },
      requestPayerName: true,
      requestPayerEmail: true,
      disableWallets: ['applePay', 'browserCard']
    });

    const elements = await stripe.elements();
    const prButton = await elements.create('paymentRequestButton', {paymentRequest});


    const result = await paymentRequest.canMakePayment();

    if (result) {
      this.hide = false;
      this.$nextTick(async () => {
        await prButton.mount('#payment-request-button-google');
        this.isLoading = false;
      });
    } else {
      document.getElementById('payment-request-button-google').style.display = 'none';
      this.isLoading = false;
      this.hide = true;
    }


    paymentRequest.on('paymentmethod', async (ev) => {
      this.isLoading = true;

      const backendData = await this.walletPreRequestAction({type: 'stripe_google_pay'})
          .catch(err => {
            console.error(err);
            this.isLoading = false;
          });

      const {paymentIntent, error: confirmError} = await stripe.confirmCardPayment(
          backendData.paymentIntent,
          {payment_method: ev.paymentMethod.id},
          {handleActions: false}
      );

      if (confirmError) {
        ev.complete('fail');
      } else {
        ev.complete('success');
        if (paymentIntent.status === "requires_action") {
          const {error} = await stripe.confirmCardPayment(clientSecret);
          if (error) {
            this.error = 'error_please_change_payment_method';
          } else {
            this.endPayment();
          }
        } else {
          this.endPayment();
        }
      }

      this.isLoading = false;
    });


  }
}
</script>
